module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1093.263e5f6e.png";